<script lang="ts" setup>

    const props = withDefaults(defineProps<{
        foldedIconClass?: string,
        unfoldedIconClass?: string,
        folded?: boolean,
        title?:string,
        foldedValue?: boolean
    }>(),{
        foldedIconClass: "fa-solid fa-chevron-right",
        unfoldedIconClass: "fa-solid fa-chevron-down",
        folded: true,
        foldedValue: true
    });

    const emit = defineEmits(["update:folded"]);

    function Toggle(){
        const newFoldedValue = !props.folded;

        emit("update:folded", newFoldedValue);
    }

</script>

<style scoped>
    .IconClass{
        font-size:1em;
        cursor: pointer;
    }
    .IconClass:hover{
        font-weight: bold;
        font-size: 1.25em;
        cursor: pointer;
    }
</style>

<template>
    <em :class="foldedIconClass" class="IconClass" v-if="folded === foldedValue" @click="Toggle()" :title="title"></em>
    <em :class="unfoldedIconClass" class="IconClass" v-if="folded !== foldedValue" @click="Toggle()" :title="title"></em>
</template>